<script setup>
import { onMounted, ref } from 'vue';
import Avatar10 from '../assets/img/loading/avatar10_11zon.webp';
import Avatar11 from '../assets/img/loading/avatar11_11zon.webp';
import Avatar12 from '../assets/img/loading/avatar12_11zon.webp';
import Avatar13 from '../assets/img/loading/avatar13_11zon.webp';
import Avatar14 from '../assets/img/loading/avatar14_11zon.webp';
import Avatar15 from '../assets/img/loading/avatar15_11zon.webp';
import Avatar16 from '../assets/img/loading/avatar16_11zon.webp';
import Avatar17 from '../assets/img/loading/avatar17_11zon.webp';
import Avatar18 from '../assets/img/loading/avatar18_11zon.webp';
import Avatar1 from '../assets/img/loading/avatar1_11zon.webp';
import Avatar2 from '../assets/img/loading/avatar2_11zon.webp';
import Avatar3 from '../assets/img/loading/avatar3_11zon.webp';
import Avatar4 from '../assets/img/loading/avatar4_11zon.webp';
import Avatar5 from '../assets/img/loading/avatar5_11zon.webp';
import Avatar6 from '../assets/img/loading/avatar6_11zon.webp';
import Avatar7 from '../assets/img/loading/avatar7_11zon.webp';
import Avatar8 from '../assets/img/loading/avatar8_11zon.webp';
import Avatar9 from '../assets/img/loading/avatar9_11zon.webp';
import Logo from '../assets/img/loading/logo_11zon.webp';
import { useClosetStore } from '../stores/closet';

const ClosetStore = useClosetStore()
const start = ref(false)
const end = ref(false)
onMounted(() => {
  setTimeout(() => {
    start.value = true
  }, 4500)

  setTimeout(() => {
    end.value = true
  }, 6200)
})
</script>

<template>
  <div class="component-loading">
    <div :class="{'loading-wrapper': true}">
      <section :class="{'avatars': true, 'hide': start}">
        <div>
          <img style="--animation-order: 1;"  :src="Avatar1" alt="">
          <img style="--animation-order: 2;"  :src="Avatar2" alt="">
          <img style="--animation-order: 3;"  :src="Avatar3" alt="">
        </div>
        <div>
          <img style="--animation-order: 4;" :src="Avatar4" alt="">
          <img style="--animation-order: 5;" :src="Avatar5" alt="">
          <img style="--animation-order: 6;" :src="Avatar6" alt="">
        </div>
        <div>
          <img style="--animation-order: 7;" :src="Avatar7" alt="">
          <img style="--animation-order: 8;" :src="Avatar8" alt="">
          <img style="--animation-order: 9;" :src="Avatar9" alt="">
        </div>
        <div>
          <img style="--animation-order: 10;" :src="Avatar10" alt="">
          <img style="--animation-order: 11;" :src="Avatar11" alt="">
          <img style="--animation-order: 12;" :src="Avatar12" alt="">
        </div>
        <div>
          <img style="--animation-order: 13;" :src="Avatar13" alt="">
          <img style="--animation-order: 14;" :src="Avatar14" alt="">
          <img style="--animation-order: 15;" :src="Avatar15" alt="">
        </div>
        <div>
          <img style="--animation-order: 16;" :src="Avatar16" alt="">
          <img style="--animation-order: 17;" :src="Avatar17" alt="">
          <img style="--animation-order: 18;" :src="Avatar18" alt="">
        </div>
      </section>
      <section class="after" v-if="start">
        <img :src="Logo" alt="">
      </section>
      <section class="after-word" v-if="end">
        Hello, {{ ClosetStore.owner['姓名'] }}
      </section>
    </div>
  </div>
</template>
